import { styled } from "../../config/stiches.config";
import * as PopoverPrimative from "@radix-ui/react-popover";

export const Popover = styled(PopoverPrimative.Root);

export const PopoverTrigger = styled(PopoverPrimative.Trigger, {
  display: "flex",
  justifyItems: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  borderRadius: "$radii$3",
  ["&:focus"]: {
    outline: "1px solid $colors$teal600",
  },
  ["&:active"]: {
    outline: "1px solid $colors$teal600",
  },
});

export const PopoverContent = styled(PopoverPrimative.Content, {
  py: "$space$3",
  px: "$space$4",
  backgroundColor: "White",
  width: "100%",
  borderRadius: "$2",
  boxShadow: "$shadow-md",
  zIndex: 499,
});

export const CalendarContainer = styled("div", {
  width: "100%",
  gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
  display: "grid",
  minWidth: "400px",
});

export const CalendarContainerSmall = styled("div", {
  width: "100%",
  gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
  display: "grid",
  minWidth: "300px",
});

export const BorderlessCalendarColumn = styled("button", {
  borderRadius: "$radii$full",
  width: "$space$10",
  height: "$space$10",
  padding: "$space$2",
  margin: "auto",
  whiteSpace: "nowrap",
  boxSizing: "box-sizing",
  cursor: "pointer",
  alignItems: "start",
  ["&:focus"]: {
    outline: "none",
    backgroundColor: "$colors$gray200",
    color: "$colors$gray600",
  },
  ["&:active"]: {
    backgroundColor: "$colors$gray200",
    color: "$colors$gray600",
  },
  ['&[data-current-selected="true"]']: {
    backgroundColor: "$colors$teal600",
    color: "White",
  },
  ['&[data-current-day="true"]']: {
    backgroundColor: "$colors$teal600",
    color: "White",
  },
  ['&[data-current-isholiday="true"]']: {
    backgroundColor: "$colors$gray200",
    color: "$colors$gray600",
    cursor: "not-allowed",
    ["&:hover"]: {
      backgroundColor: "$colors$gray200",
      color: "$colors$gray600",
    },
  },
  ['&[data-user-selected="true"]']: {
    backgroundColor: "$colors$gray200",
    color: "$colors$gray600",
  },
  ['&[data-user-selected-teal="true"]']: {
    backgroundColor: "$colors$teal200",
    color: "$colors$gray600",
  },
  variants: {
    cols: {
      col1: {
        gridColumn: "span 1 / span 1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: "$space$2",
        ["&:hover"]: {
          backgroundColor: "$colors$gray200",
          color: "$colors$gray600",
        },
      },
      col2: {
        gridColumn: "span 2 / span 2",
      },
    },
    firstItem: {
      true: {
        position: "relative",
        ["&::before"]: {
          content: "",
          position: "absolute",
          top: -1,
          bottom: 0,
          left: 0,
          width: "12px",
          borderLeft: "$$borderStyle",
          btlr: "$2",
          ml: "-1px",
        },
      },
    },
    firstIndex: {
      true: {},
    },
    emptyCell: {
      true: {
        ["&:hover"]: {
          backgroundColor: "transparent",
          cursor: "unset",
          pointerEvents: "none",
        },
      },
    },
    disableDate: {
      true: {
        backgroundColor: "$colors$gray100",
        color: "$colors$gray600",
        // borderRadius: 0,
        // margin: 0,
        width: "$space$10",
        height: "$space$10",
      },
    },
    selectTeal: {
      true: {
        backgroundColor: "$colors$teal100",
      },
    },
  },
  defaultVariants: {
    cols: "col1",
  },
  compoundVariants: [
    {
      firstIndex: true,
      firstItem: true,
      css: {
        ["&::before"]: {
          ml: "0px",
        },
      },
    },
  ],
});
export const CalendarColumn = styled("button", {
  $$borderStyle: "1px solid $colors$gray200",
  whiteSpace: "nowrap",
  boxSizing: "box-sizing",
  cursor: "pointer",
  ["&:focus"]: {
    outline: "none",
    backgroundColor: "$colors$teal600",
    color: "White",
  },
  ["&:active"]: {
    backgroundColor: "$colors$teal600",
    color: "White",
  },
  ['&[data-current-selected="true"]']: {
    backgroundColor: "$colors$teal600",
    color: "White",
  },
  ['&[data-current-day="true"]']: {
    backgroundColor: "$colors$teal100",
    color: "$colors$teal700",
  },
  ['&[data-current-isholiday="true"]']: {
    backgroundColor: "$colors$gray200",
    color: "$colors$gray600",
    cursor: "not-allowed",
    ["&:hover"]: {
      backgroundColor: "$colors$gray200",
      color: "$colors$gray600",
    },
    ["&[disableDate='true']"]: {
      backgroundColor: "$colors$gray200",
      color: "$colors$gray600",
      cursor: "not-allowed",
    },
  },
  variants: {
    cols: {
      col1: {
        gridColumn: "span 1 / span 1",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: "$space$2",
        ["&:hover"]: {
          backgroundColor: "$colors$teal600",
          color: "White",
        },
      },
      col2: {
        gridColumn: "span 2 / span 2",
      },
    },
    topLeft: {
      true: {
        borderTop: "$$borderStyle",
        borderRight: "$$borderStyle",
        btlr: "$2",
      },
    },
    topRight: {
      true: {
        btrr: "$1",
      },
    },
    topBorder: {
      true: {
        borderTop: "$$borderStyle",
      },
    },
    rightBorder: {
      true: {
        borderRight: "$$borderStyle",
      },
    },
    leftBorder: {
      true: {
        borderLeft: "$$borderStyle",
      },
    },
    bottomRight: {
      true: {
        bbrr: "$2",
        borderBottom: "$$borderStyle",
      },
    },
    bottomSecondToLastRow: {
      true: {
        borderBottom: "$$borderStyle",
        bbrr: "$2",
        mb: "-1px",
      },
    },
    bottomSecondLast: {
      true: {
        mb: "-1px",
      },
    },
    bottomRow: {
      true: {
        borderBottom: "$$borderStyle",
      },
    },
    bottomLeft: {
      true: {
        borderBottom: "$$borderStyle",
        bblr: "$2",
      },
    },
    disableDate: {
      true: {
        backgroundColor: "$colors$gray200",
        color: "$colors$gray600",
      },
    },
    firstItem: {
      true: {
        position: "relative",
        ["&::before"]: {
          content: "",
          position: "absolute",
          top: -1,
          bottom: 0,
          left: 0,
          width: "12px",
          borderLeft: "$$borderStyle",
          btlr: "$2",
          ml: "-1px",
        },
      },
    },
    firstIndex: {
      true: {},
    },
    emptyCell: {
      true: {
        ["&:hover"]: {
          backgroundColor: "transparent",
          cursor: "unset",
          pointerEvents: "none",
        },
      },
    },
  },
  defaultVariants: {
    cols: "col1",
  },
  compoundVariants: [
    {
      firstIndex: true,
      firstItem: true,
      css: {
        ["&::before"]: {
          ml: "0px",
        },
      },
    },
  ],
});

export const Grid = styled("div", {
  width: "100%",
  gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
  display: "grid",
});

export const Cols = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  variants: {
    colSize: {
      col1: {
        gridColumn: "span 1 / span 1",
      },
      col5: {
        gridColumn: "span 5 / span 5",
      },
      col7: {
        gridColumn: "span 7 / span 7",
      },
    },
  },
  defaultVariants: {
    colSize: "$1",
  },
});
